import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { Skeleton } from '@/components/ui/app-skeleton';
export function FundingLoading(t0) {
  const $ = _c(14);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    banks: t2,
    withdrawal: t3
  } = t1;
  const banks = t2 === undefined ? false : t2;
  const withdrawal = t3 === undefined ? false : t3;
  const t = useTranslations("onramp");
  let t4;
  if ($[2] !== t) {
    t4 = t("checking_methods");
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== withdrawal) {
    t5 = withdrawal ? <Skeleton className="h-3 w-28 rounded-pill" aria-hidden="true" /> : null;
    $[4] = withdrawal;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <MethodRows count={4} />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== banks || $[8] !== withdrawal) {
    t7 = banks || withdrawal ? <div className="flex flex-col gap-2" aria-hidden="true"><Skeleton className="h-3 w-28 rounded-pill" /><MethodRows count={withdrawal ? 1 : 2} /></div> : null;
    $[7] = banks;
    $[8] = withdrawal;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t7) {
    t8 = <output aria-label={t4} aria-busy="true" className="flex flex-col gap-4">{t5}{t6}{t7}</output>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}
function MethodRows(t0) {
  const $ = _c(3);
  const {
    count
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["first", "second", "third", "fourth"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== count) {
    t2 = <div className="overflow-hidden rounded-control bg-background-tertiary" aria-hidden="true">{t1.slice(0, count).map(_temp)}</div>;
    $[1] = count;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp(id) {
  return <div key={id} className="flex min-h-16.5 items-center gap-3 p-3"><Skeleton className="size-10 shrink-0 rounded-control" /><div className="flex flex-1 flex-col gap-2"><Skeleton className="h-4 w-32 rounded-pill" /><Skeleton className="h-3 w-20 rounded-pill" /></div><Skeleton className="size-3 rounded-pill" /></div>;
}